module.exports = __webpack_public_path__ + "static/apple-touch-icon-72x72-324101ffd4d835d68d27c14bc108b734.png";